import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

import { AuthService } from '../../../core/services/auth.service';
import { PartnerContextService } from '../../../core/services/partner-context.service';
import { ThemeToggleComponent } from '@stretchit/ui-theme';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatButtonModule, ThemeToggleComponent],
})
export class HeaderComponent {
  /**
   * Partner the panel is currently working with, shown on the left: the name the backend
   * answered with at sign-in, or the slug from the address while there is no session to
   * take a name from.
   */
  readonly partnerLabel: Signal<string>;

  /** Partner segment the brand link leads to — the panel's main page. */
  readonly partnerSlug: Signal<string>;

  constructor(
    private authService: AuthService,
    private router: Router,
    private partnerContext: PartnerContextService
  ) {
    this.partnerLabel = computed(() => authService.partner()?.name ?? partnerContext.slug);
    this.partnerSlug = partnerContext.slugSignal;
  }

  /** Signing out returns to the login page of the SAME partner, not to a shared one. */
  logout(): void {
    this.authService.logout();
    this.router.navigate(['/', this.partnerContext.slug, 'login']);
  }
}
